import { AgencyDashboard } from "../dashboard/AgencyDashboard";
import { TeamDashboard } from "../dashboard/TeamDashboard";
import { useRole } from "../misc/useRole";
import { ClientPortal } from "./ClientPortal";

// Home page per role: the agency dashboard for admins, their own work for
// the team, and the client portal for client users.
export const RoleDashboard = () => {
  const { role, isPending } = useRole();
  if (isPending) return null;
  if (role === "client") return <ClientPortal />;
  if (role === "team") return <TeamDashboard />;
  return <AgencyDashboard />;
};
